export default (prop, type) => {
  return {
    ...prop[type],
    description: prop.description,
    title: prop.title,
  };
};
